import { AnyStateWithError } from './types';
import { createSelector } from 'reselect';

const getState = (state: AnyStateWithError) => state.error;

export const getError = createSelector(getState, error => {
	return error;
});
